
import { retrieveData } from "./helper";

export const getToken = () => {
  const token = retrieveData("auth");
  return token;
};
